/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityChangeType } from './EntityChangeType';
import {
    EntityChangeTypeFromJSON,
    EntityChangeTypeFromJSONTyped,
    EntityChangeTypeToJSON,
} from './EntityChangeType';
import type { EntityWithHistoryType } from './EntityWithHistoryType';
import {
    EntityWithHistoryTypeFromJSON,
    EntityWithHistoryTypeFromJSONTyped,
    EntityWithHistoryTypeToJSON,
} from './EntityWithHistoryType';
import type { HistoryDtoHiddenEntityType } from './HistoryDtoHiddenEntityType';
import {
    HistoryDtoHiddenEntityTypeFromJSON,
    HistoryDtoHiddenEntityTypeFromJSONTyped,
    HistoryDtoHiddenEntityTypeToJSON,
} from './HistoryDtoHiddenEntityType';
import type { PropertyChangeSectionDto } from './PropertyChangeSectionDto';
import {
    PropertyChangeSectionDtoFromJSON,
    PropertyChangeSectionDtoFromJSONTyped,
    PropertyChangeSectionDtoToJSON,
} from './PropertyChangeSectionDto';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';

/**
 * 
 * @export
 * @interface HistoryDto
 */
export interface HistoryDto {
    /**
     * 
     * @type {EntityChangeType}
     * @memberof HistoryDto
     */
    changeType?: EntityChangeType;
    /**
     * 
     * @type {EntityWithHistoryType}
     * @memberof HistoryDto
     */
    entityType?: EntityWithHistoryType;
    /**
     * 
     * @type {HistoryDtoHiddenEntityType}
     * @memberof HistoryDto
     */
    hiddenEntityType?: HistoryDtoHiddenEntityType | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryDto
     */
    changeTime?: string;
    /**
     * 
     * @type {number}
     * @memberof HistoryDto
     */
    userId?: number | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof HistoryDto
     */
    user?: HistoryDtoUser | null;
    /**
     * 
     * @type {Array<PropertyChangeSectionDto>}
     * @memberof HistoryDto
     */
    propertyChangeSections?: Array<PropertyChangeSectionDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof HistoryDto
     */
    summary?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryDto
     */
    $type?: HistoryDtoTypeEnum;
}


/**
 * @export
 */
export const HistoryDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedEntityHistoryHistoryDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.EntityHistory.HistoryDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type HistoryDtoTypeEnum = typeof HistoryDtoTypeEnum[keyof typeof HistoryDtoTypeEnum];



/**
 * Check if a given object implements the HistoryDto interface.
 */
export function instanceOfHistoryDto(value?: unknown): value is HistoryDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(HistoryDtoTypeEnum)[0];
}

export function HistoryDtoFromJSON(json: any): HistoryDto {
    return HistoryDtoFromJSONTyped(json, false);
}

export function HistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'changeType': json['changeType'] == null ? undefined : EntityChangeTypeFromJSON(json['changeType']),
        'entityType': json['entityType'] == null ? undefined : EntityWithHistoryTypeFromJSON(json['entityType']),
        'hiddenEntityType': json['hiddenEntityType'] == null ? undefined : HistoryDtoHiddenEntityTypeFromJSON(json['hiddenEntityType']),
        'changeTime': json['changeTime'] == null ? undefined : json['changeTime'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'user': json['user'] == null ? undefined : HistoryDtoUserFromJSON(json['user']),
        'propertyChangeSections': json['propertyChangeSections'] == null ? undefined : ((json['propertyChangeSections'] as Array<any>).map(PropertyChangeSectionDtoFromJSON)),
        'summary': json['summary'] == null ? undefined : json['summary'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function HistoryDtoToJSON(value?: HistoryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'changeType': EntityChangeTypeToJSON(value['changeType']),
        'entityType': EntityWithHistoryTypeToJSON(value['entityType']),
        'hiddenEntityType': HistoryDtoHiddenEntityTypeToJSON(value['hiddenEntityType']),
        'changeTime': value['changeTime'],
        'userId': value['userId'],
        'user': HistoryDtoUserToJSON(value['user']),
        'propertyChangeSections': value['propertyChangeSections'] == null ? undefined : ((value['propertyChangeSections'] as Array<any>).map(PropertyChangeSectionDtoToJSON)),
        'summary': value['summary'],
        '$type': value['$type'],
    });
}

